/* Original motion treatments informed by Interface Shelf Animated Tabs.
   Form data, validation and submission remain owned by the existing forms. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  const ease = 'cubic-bezier(.22,1,.36,1)';
  const visible = (node) => {
    const r = node.getBoundingClientRect();
    return !document.hidden && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight;
  };
  function move(node, frames, duration = 240) {
    if (!node?.animate || reduced.matches || !visible(node)) return;
    const animation = node.animate(frames, { duration, easing: ease });
    active.add(animation);
    animation.finished.catch(() => {}).finally(() => active.delete(animation));
  }
  function stop() { active.forEach((animation) => animation.cancel()); active.clear(); }
  reduced.addEventListener('change', stop);
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const entry of entries) if (!entry.isIntersecting) {
      active.forEach((animation) => { if (entry.target.contains(animation.effect?.target)) animation.cancel(); });
    }
  }) : null;

  function selectTrack(track, selected) {
    if (!track || track.dataset.cgsmReady) return;
    track.dataset.cgsmReady = 'true';
    track.classList.add('cgsm-track');
    const indicator = document.createElement('span');
    indicator.className = 'cgsm-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    track.prepend(indicator);
    let previous;
    function update(animate = true) {
      const target = selected();
      if (!target) { indicator.hidden = true; previous = null; return; }
      indicator.hidden = false;
      const base = track.getBoundingClientRect(), rect = target.getBoundingClientRect();
      const next = { x: rect.left - base.left + track.scrollLeft, y: rect.top - base.top + track.scrollTop, w: rect.width, h: rect.height };
      Object.assign(indicator.style, { left: `${next.x}px`, top: `${next.y}px`, width: `${next.w}px`, height: `${next.h}px` });
      if (animate && previous && previous.w && next.w) {
        move(indicator, [
          { transform: `translate(${previous.x-next.x}px,${previous.y-next.y}px) scale(${previous.w/next.w},${previous.h/next.h})` },
          { transform: 'none' },
        ]);
      }
      previous = next;
    }
    track.addEventListener('change', () => update());
    track.addEventListener('click', () => requestAnimationFrame(() => update()));
    window.addEventListener('resize', () => update(false), { passive: true });
    update(false);
    observer?.observe(track);
  }

  document.querySelectorAll('.cgsm-topics').forEach((group) => {
    selectTrack(group.querySelector('.cgsm-topic-list'), () => group.querySelector('input:checked')?.closest('label'));
  });

  const rights = document.querySelector('[data-cgrg-root]');
  if (rights) {
    const choices = rights.querySelector('[data-cgrg-choice]')?.parentElement;
    const result = rights.querySelector('[data-cgrg-result]');
    selectTrack(choices, () => choices.querySelector('[aria-pressed="true"]'));
    choices?.addEventListener('click', (event) => {
      if (!event.target.closest('[data-cgrg-choice]') || !result) return;
      const before = result.getBoundingClientRect().height;
      requestAnimationFrame(() => {
        const after = result.getBoundingClientRect().height;
        move(result, [{ height: `${before}px` }, { height: `${after}px` }], 220);
        move(result.querySelector('h3'), [{ opacity: .6, transform: 'translateY(5px)' }, { opacity: 1, transform: 'none' }], 220);
      });
    }, { capture: true });
    if (result) observer?.observe(result);
  }

  const warranty = document.querySelector('[data-cgwc-root]');
  warranty?.addEventListener('cgau:support-step', (event) => {
    const { previous, current } = event.detail;
    const panel = warranty.querySelector(`[data-cgwc-step="${current}"]`);
    move(panel, [{ opacity: .65, transform: `translateX(${current < previous ? -12 : 12}px)` }, { opacity: 1, transform: 'none' }]);
  });
  if (warranty) observer?.observe(warranty);

  // Only server-rendered contact success or the existing confirmed claim panel
  // can trigger this receipt. A click, sending state or validation never does.
  document.querySelectorAll('.contact-form__success, [data-cgwc-success]').forEach((receipt) => {
    let played = false;
    function confirmed() {
      if (played || receipt.hidden || receipt.closest('[hidden]')) return;
      if (receipt.hasAttribute('data-cgwc-success') && !receipt.querySelector('[data-cgwc-claim-id]')?.textContent.trim()) return;
      played = true;
      move(receipt.querySelector('svg, .cgwc-success__icon') || receipt, [
        { opacity: .4, transform: 'translateY(6px) scale(.96)' },
        { opacity: 1, transform: 'none' },
      ], 320);
    }
    confirmed();
    if (!played) new MutationObserver(confirmed).observe(receipt, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
    observer?.observe(receipt);
  });
})();
